module.exports = __webpack_public_path__ + "static/media/FVS.VerwendungVonCookies.09194e53.pdf";